import React, { useCallback, useRef, useState, useEffect } from "react";
import ReactFlow, {
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
  applyEdgeChanges,
  applyNodeChanges,
  Panel,
  useReactFlow,
  ReactFlowProvider,
} from "reactflow";

import "reactflow/dist/style.css";
import CircleNode from "../../components/circle/CircleNode.jsx";
import RectangleNode from "../../components/rectangle/RectangleNode.jsx";
import CardNode from "../../components/card/CardNode.jsx";
import DownloadButton from "../../components/downloadButton/DownloadButton.jsx";
import ZoomTransition from "../../components/zoomTransition/ZoomTransition.jsx";
import ConnectionLine from "../../components/connectionLine/ConnectionLine.jsx";
import initialNodes from "../../datas/nodes.js";
import initialEdges from "../../datas/edges.js";
import About from "../../components/about/About.jsx";
import ContextMenu from "../../components/contextMenu/ContextMenu.jsx";
import ContextMenuNode from "../../components/contextMenuNode/ContextMenuNode.jsx";

const rfStyle = {
  backgroundColor: "#eefecd",
};

const nodeTypes = {
  circle: CircleNode,
  rectangle: RectangleNode,
  card: CardNode,
};

export default function Home() {
  const [nodes, setNodes] = useNodesState(initialNodes);
  const [edges, setEdges] = useEdgesState(initialEdges);
  const [menu, setMenu] = useState(null);
  const [menuNode, setMenuNode] = useState(null);
  const ref = useRef(null);

  const onNodesChange = useCallback(
    (changes) => setNodes((nds) => applyNodeChanges(changes, nds)),
    [setNodes]
  );
  const onEdgesChange = useCallback(
    (changes) => setEdges((eds) => applyEdgeChanges(changes, eds)),
    [setEdges]
  );

  const onConnect = useCallback((params) => {
    // reset the start node on connections
    setEdges((eds) => addEdge(params, eds));
  }, []);

  const onConnectStart = useCallback((_, { nodeId }) => {}, []);

  const onNodeContextMenu = useCallback(
    (event, node) => {
      // Prevent native context menu from showing
      event.preventDefault();
      // Calculate position of the context menu. We want to make sure it
      // doesn't get positioned off-screen.
      const pane = ref.current.getBoundingClientRect();
      setMenuNode({
        id: node.id,
        top: event.clientY < pane.height - 200 && event.clientY,
        left: event.clientX < pane.width - 200 && event.clientX,
        right: event.clientX >= pane.width - 200 && pane.width - event.clientX,
        bottom:
          event.clientY >= pane.height - 200 && pane.height - event.clientY,
      });
    },
    [setMenuNode]
  );
  const onContextMenu = useCallback(
    (event) => {
      // Prevent native context menu from showing
      event.preventDefault();
      // Calculate position of the context menu. We want to make sure it
      // doesn't get positioned off-screen.
      const pane = ref.current.getBoundingClientRect();
      setMenu({
        top: event.clientY < pane.height - 200 && event.clientY,
        left: event.clientX < pane.width - 200 && event.clientX,
        right: event.clientX >= pane.width - 200 && pane.width - event.clientX,
        bottom:
          event.clientY >= pane.height - 200 && pane.height - event.clientY,
      });
    },
    [setMenu]
  );

  // Close the context menu if it's open whenever the window is clicked.
  const onPaneClick = useCallback(() => {
    setMenu(null);
    setMenuNode(null);
  }, [setMenu]);

  const onConnectEnd = useCallback((event) => {
    console.log("later");
  }, []);

  useEffect(() => {
    setTimeout(() => {
      document.getElementById("home").click();
    }, 1000);
  }, []);
  return (
    <ReactFlowProvider>
      <div
        style={{ width: "100vw", height: "100vh" }}
        className="text-3xl font-bold underline"
      >
        <ReactFlow
          ref={ref}
          nodes={nodes}
          edges={edges}
          onNodesChange={onNodesChange}
          onEdgesChange={onEdgesChange}
          onConnect={onConnect}
          nodeTypes={nodeTypes}
          fitView
          style={rfStyle}
          // connectionLineComponent={ConnectionLine}
          onPaneClick={onPaneClick}
          onNodeContextMenu={onNodeContextMenu}
          onConnectStart={onConnectStart}
          onConnectEnd={onConnectEnd}
          onContextMenu={onContextMenu}
        >
          <MiniMap zoomable pannable />
          <Background variant="dots" gap={12} size={1} />
          <DownloadButton />
          <ZoomTransition />
          <About />
          {/* {menu && <ContextMenu onClick={onPaneClick} {...menu} />} */}
          {/* {menuNode && <ContextMenuNode onClick={onPaneClick} {...menuNode} />} */}
        </ReactFlow>
      </div>
    </ReactFlowProvider>
  );
}
